import React, { useState, useEffect } from "react";
import { Rept, sto } from "../../../../Context/InshData";
import Grid from "@material-ui/core/Grid";
import HeaderAll from "../../../HeaderAll";

function HeaderSales({ info }) {
  const styf = { fontWeight: "1200" };
  const styfC = { fontWeight: "500" };

  return (
    <Grid item container
      justifyContent="center"
      style={{
        paddingTop: "1rem", fontWeight: "bold", fontFamily: "Amiri-Regular",
      }}>
      <HeaderAll Report={true} found={info} />
      <Grid item container style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
        <Grid item xs={12} style={{
          fontFamily: "Amiri-Regular", border: "solid 2px", paddingTop: "0.5rem", paddingBottom: "0.5rem",
          borderRadius: "5px", textAlign: "center",
        }}
        >
          <div style={styf}>
            {Rept.title}
          </div>
        </Grid>
      </Grid>
      <Grid item container style={{
        fontFamily: "Amiri-Regular", padding: "0.3rem", border: "solid 2px",
        borderRadius: "5px", direction: "rtl",
      }}
      >
        <Grid item xs={12} container>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            {"الفرع"} /{" "} {Rept.branch}
          </Grid>

          <Grid item xs={4} style={{ textAlign: "right" }}>
            {"العميل"} /{" "} {Rept.custName}
          </Grid>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            {Rept.from} /{" "} {Rept.typeName}
          </Grid>
          <Grid item xs={3}>
            <div style={styfC}>{"من تاريخ"}{"    /"} {Rept.fDate}</div>
          </Grid>
          <Grid item xs={3}>
            <div style={styfC}> {"إلى تاريخ"}{"     /"} {Rept.tDate}</div>
          </Grid>
          <Grid item xs={2}>
            {"المستخدم"}  {"   /"}  {"------"}
          </Grid>
          <Grid item xs={4}>
            {"تاريخ الطباعة"} {"    /"} {Rept.nDate}
          </Grid>
        </Grid>
        {/* <Grid item xs={12} container  style={{ textAlign: "right" ,paddingTop:"0.3rem"}}>
          
        
         
        </Grid> */}
      </Grid>
    </Grid>
  );
}
export default HeaderSales;